import { PropTypes } from 'prop-types'
import React, { useEffect, useState } from 'react'

import { isFunction } from 'helpers/miscellaneous'

import { Content, Overlay, Body, CloseBtn } from './styles'

const Modal = ({
    open,
    children,
    closeOnOutsideClick,
    onClose,
    displayCloseBtn,
}) => {
    const [show, setShow] = useState(open)

    useEffect(() => setShow(open), [open])

    useEffect(() => {
        const modalBodyRef = document.getElementById('modal-body-ref')
        const handleClickOutside = event => {
            if (modalBodyRef && !modalBodyRef?.contains(event.target) && show) {
                onOutsideClick()
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () =>
            document.removeEventListener('mousedown', handleClickOutside)
    }, [show])

    if (!show) return null

    const onCloseClick = () => {
        isFunction(onClose) && onClose()
        setShow(false)
    }

    const onOutsideClick = () => closeOnOutsideClick && onCloseClick()

    return (
        <Overlay>
            {/* <Slide cascade={false} triggerOnce direction="top"> */}
            <Body id="modal-body-ref">
                {displayCloseBtn && (
                    <CloseBtn
                        onClick={onCloseClick}
                        src="/assets/controls/latest/modal_close.svg"
                    />
                )}
                <Content>{children}</Content>
            </Body>
            {/* </Slide> */}
        </Overlay>
    )
}

Modal.propTypes = {
    closeOnOutsideClick: PropTypes.bool,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    displayCloseBtn: PropTypes.bool,
}

Modal.defaultProps = {
    closeOnOutsideClick: false,
    open: false,
    onClose: null,
    displayCloseBtn: true,
}

export default Modal
